import { render, staticRenderFns } from "./permintaan_darah.vue?vue&type=template&id=e5acda4c&scoped=true"
import script from "./permintaan_darah.vue?vue&type=script&lang=js"
export * from "./permintaan_darah.vue?vue&type=script&lang=js"
import style0 from "./permintaan_darah.vue?vue&type=style&index=0&id=e5acda4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5acda4c",
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSelect,QBadge,QPagination,QDialog,QOptionGroup,QCardActions,QSeparator,QList,QItem,QItemSection,QItemLabel,QChip,QSpace,QForm,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSelect,QBadge,QPagination,QDialog,QOptionGroup,QCardActions,QSeparator,QList,QItem,QItemSection,QItemLabel,QChip,QSpace,QForm})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
